import React from "react";

const Farms = () => <div className="farms">Add Product</div>;

export default Farms;